import React from 'react';
import './Footer.css';
import logo from "../assets/airbooked.png";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* Company Information Section */}
        <div className="footer-info">
          <div className="footer-logo">
            <img className="logo" src={logo} alt="AirBooked logo" />
          </div>
          <p className="footer-info-text">
            Our company is a leading provider in Australia, managing properties nationwide, including key locations
            across Victoria and Queensland. We focus on enhancing homeowners' earnings while ensuring a smooth
            and memorable experience for guests by leveraging cutting-edge technology and a skilled local team.
          </p>
        </div>

        {/* Contact Section */}
        <div className="footer-contact">
          <p className="footer-contact-item">
            Email: <a className="footer-contact-link" href="mailto:sales@sprucelyclean.com">sales@sprucelyclean.com</a>
          </p>
          <p className="footer-contact-item">
            Phone: <a className="footer-contact-link" href="tel:+61433310964">+61 433 310 964</a>
          </p>
        </div>

        {/* Services Section */}
        <div className="footer-services">
          <h4 className="footer-services-title">SERVICES</h4>
          <ul className="footer-services-list">
            <li className="footer-services-item">Property Styling</li>
            <li className="footer-services-item">Booking Management</li>
            <li className="footer-services-item">Short Stay Marketing</li>
            <li className="footer-services-item">Customer Communication</li>
            <li className="footer-services-item">Professional Cleaning Service</li>
            <li className="footer-services-item">Guest Stays</li>
            <li className="footer-services-item">Maintenance Management</li>
            <li className="footer-services-item">Host Mentoring</li>
            <li className="footer-services-item">Guest Reviews</li>
          </ul>
        </div>

        {/* Locations Section */}
        <div className="footer-locations">
          <h4 className="footer-locations-title">LOCATIONS</h4>
          <ul className="footer-locations-list">
            <li className="footer-locations-item">
              <Link className="footer-locations-link" to="/HomeMelbourne">Melbourne</Link>
            </li>
            <li className="footer-locations-item">
              <Link className="footer-locations-link" to="/HomeMorningtonPeninsula">Mornington Peninsula</Link>
            </li>
            <li className="footer-locations-item">
              <Link className="footer-locations-link" to="/HomeGreatOceanRd">Great Ocean Rd</Link>
            </li>
            <li className="footer-locations-item">
              <Link className="footer-locations-link" to="/HomeCountryVictoria">Country Victoria</Link>
            </li>

            {/* Keep or remove the interstate links below depending on your routing/pages */}
            {/* <li className="footer-locations-item"><Link className="footer-locations-link" to="/locations/adelaide">Adelaide</Link></li> */}
            {/* ... */}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-bottom-text">&copy; {new Date().getFullYear()} AirBooked. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;


